import { PureComponent, PropsWithChildren } from "react";

export default class CustomizeDataEditorPropertyLabel extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-customize-data-editor__property-label">
        {this.props.children}
      </div>
    );
  }
}
